import React from 'react';
import { injectIntl } from 'react-intl';

import ReactEcharts from 'components/HTMLElements/ReactECharts';
import ChartConfig from 'constants/ChartConfig';
import _ from "lodash";

const Chart = ( { data = {}, intl, chatActive, phoneActive } ) => {
  const area = {};
  var variableValue = undefined;
  var variableValues = ['HIGH', 'NEUTRAL', 'LOW', null];
  var variableName = 'TONE';
  const seriesYdata = {};
  const series = [
    intl.formatMessage( { id: "facebook" } ),
    intl.formatMessage( { id: "twitter" } ),
    intl.formatMessage( { id: "email" } ),
    intl.formatMessage( { id: "walkin" } ),
  ];
  if( phoneActive ) series.push( intl.formatMessage( { id: "phone" } ) )
  if( chatActive ) series.push( intl.formatMessage( { id: "chat" } ) )


  variableValue = 'HIGH';
  seriesYdata[variableValue] = [
    _.filter( data['FACEBOOK'], [variableName, variableValue ] ).length > 0 ? _.filter( data['FACEBOOK'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['TWITTER'], [variableName, variableValue ] ).length > 0 ? _.filter( data['TWITTER'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['EMAIL'], [variableName, variableValue ] ).length > 0 ? _.filter( data['EMAIL'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['WALK_IN'], [variableName, variableValue ] ).length > 0 ? _.filter( data['WALK_IN'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
  ]
  if( phoneActive ) seriesYdata[variableValue].push( _.filter( data['PHONE'], [variableName, variableValue ] ).length > 0 ? _.filter( data['PHONE'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )
  if( chatActive ) seriesYdata[variableValue].push( _.filter( data['CHAT'], [variableName, variableValue ] ).length > 0 ? _.filter( data['CHAT'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )


  variableValue = 'NEUTRAL';
  seriesYdata[variableValue] = [
    _.filter( data['FACEBOOK'], [variableName, variableValue ] ).length > 0 ? _.filter( data['FACEBOOK'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['TWITTER'], [variableName, variableValue ] ).length > 0 ? _.filter( data['TWITTER'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['EMAIL'], [variableName, variableValue ] ).length > 0 ? _.filter( data['EMAIL'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['WALK_IN'], [variableName, variableValue ] ).length > 0 ? _.filter( data['WALK_IN'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
  ]
  if( phoneActive ) seriesYdata[variableValue].push( _.filter( data['PHONE'], [variableName, variableValue ] ).length > 0 ? _.filter( data['PHONE'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )
  if( chatActive ) seriesYdata[variableValue].push( _.filter( data['CHAT'], [variableName, variableValue ] ).length > 0 ? _.filter( data['CHAT'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )

  variableValue = 'LOW';
  seriesYdata[variableValue] = [
    _.filter( data['FACEBOOK'], [variableName, variableValue ] ).length > 0 ? _.filter( data['FACEBOOK'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['TWITTER'], [variableName, variableValue ] ).length > 0 ? _.filter( data['TWITTER'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['EMAIL'], [variableName, variableValue ] ).length > 0 ? _.filter( data['EMAIL'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['WALK_IN'], [variableName, variableValue ] ).length > 0 ? _.filter( data['WALK_IN'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
  ]
  if( phoneActive ) seriesYdata[variableValue].push( _.filter( data['PHONE'], [variableName, variableValue ] ).length > 0 ? _.filter( data['PHONE'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )
  if( chatActive ) seriesYdata[variableValue].push( _.filter( data['CHAT'], [variableName, variableValue ] ).length > 0 ? _.filter( data['CHAT'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )


  variableValue = null;
  seriesYdata['null'] = [
    _.filter( data['FACEBOOK'], [variableName, variableValue ] ).length > 0 ? _.filter( data['FACEBOOK'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['TWITTER'], [variableName, variableValue ] ).length > 0 ? _.filter( data['TWITTER'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['EMAIL'], [variableName, variableValue ] ).length > 0 ? _.filter( data['EMAIL'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
    _.filter( data['WALK_IN'], [variableName, variableValue ] ).length > 0 ? _.filter( data['WALK_IN'], [variableName, variableValue ] )[0]["TOTAL"] : 0,
  ]
  if( phoneActive ) seriesYdata[variableValue].push( _.filter( data['PHONE'], [variableName, variableValue ] ).length > 0 ? _.filter( data['PHONE'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )
  if( chatActive ) seriesYdata[variableValue].push( _.filter( data['CHAT'], [variableName, variableValue ] ).length > 0 ? _.filter( data['CHAT'], [variableName, variableValue ] )[0]["TOTAL"] : 0 )

  area.options = {
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: [intl.formatMessage( { id: "high" } ), intl.formatMessage( { id: "neutral" } ), intl.formatMessage( { id: "low" } ), intl.formatMessage( { id: "undefined" } )],
      textStyle: {
        color: ChartConfig.color.text
      }
    },
    toolbox: {
      show: false
    },
    calculable: true,
    xAxis: [
      {
        type: 'category',
        data: series,
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        }
      }
    ],
    yAxis: [
      {
        axisLabel: {
          textStyle: {
            color: ChartConfig.color.text
          }
        },
        splitLine: {
          lineStyle: {
            color: ChartConfig.color.splitLine
          }
        },
        splitArea: {
          show: true,
          areaStyle: {
            color: ChartConfig.color.splitArea
          }
        }
      }
    ],
    series: [
      {
        name: intl.formatMessage( { id: "high" } ),
        type: 'bar',
        data: seriesYdata['HIGH'],
        itemStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.info
          }
        },
        symbol: 'diamond'
      },
      {
        name: intl.formatMessage( { id: "neutral" } ),
        type: 'bar',
        barCategoryGap: '35%',
        data: seriesYdata['NEUTRAL'],
        itemStyle: {
          normal: {
            color: ChartConfig.color.warning
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.warning
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.warning
          }
        },
        symbol: 'diamond'
      },
      {
        name: intl.formatMessage( { id: "low" } ),
        type: 'bar',
        barCategoryGap: '35%',
        data: seriesYdata['LOW'],
        itemStyle: {
          normal: {
            color: ChartConfig.color.danger
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.danger
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.danger
          }
        },
        symbol: 'diamond'
      },
      {
        name: intl.formatMessage( { id: "undefined" } ),
        type: 'bar',
        barCategoryGap: '35%',
        data: seriesYdata['null'],
        itemStyle: {
          normal: {
            color: ChartConfig.color.gray2
          }
        },
        lineStyle: {
          normal: {
            color: ChartConfig.color.gray2
          }
        },
        areaStyle: {
          normal: {
            color: ChartConfig.color.gray2
          }
        },
        symbol: 'diamond'
      }
    ]
  };
  return (
    <ReactEcharts style={{ height: '300px' }} option={area.options} showLoading={false}/> );
};

module.exports = injectIntl( Chart );



// WEBPACK FOOTER //
// ./routes/app/components/Dashboard/ToneKPIsChart.js